module.exports = __webpack_public_path__ + "static/img/icon6-9.41cba091.png";